import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Fields } from '@app/services/selective-processes/fields/fields';
import { Observable } from 'rxjs/internal/Observable';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-autocomplete-system-fields',
  templateUrl: './autocomplete-system-fields.component.html',
  styleUrls: ['./autocomplete-system-fields.component.scss']
})
export class AutocompleteSystemFieldsComponent implements OnInit {

  @Input() systemFields: Fields[] = [];
  @Input() formulario: FormGroup;
  @Input() nameControl: string;
  @Input() label: string;
  @Input() hint = '';
  @Input() matTooltipText = '';

  public filteredSystemFieldOptions: Observable<any>;

  constructor() { }

  ngOnInit(): void {
    this.manageNameControl();
    this.searchTheCompleteFieldData();
  }

  private searchTheCompleteFieldData() {
    this.systemFields.map(value => {
      if (value.field_id === this.fieldValueInControl) {
        this.setFieldDataNoForm(value);
      }
    });
  }

  private setFieldDataNoForm(FieldValue) {
    this.formulario.get(this.nameControl).patchValue(FieldValue);
  }

  public manageNameControl() {
    this.filteredSystemFieldOptions = this.formulario.get(this.nameControl).valueChanges
      .pipe(
        startWith(''),
        map(option => option ? this.systemFieldOptionsFilter(option) : this.systemFields.slice())
      );
  }

  private systemFieldOptionsFilter(value: number | string): Fields[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.systemFields.filter((option) =>
        option.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').match(filterValue)).sort((a, b) => {
          if (a.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') <
            b.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return -1;
          } else if (a.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') >
            b.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return 1;
          } else {
            return 0;
          }
        });
    } else {
      return [];
    }
  }

  public displayFn(field?): string | undefined {
    return field ? field.label : undefined;
  }


  public get fieldValueInControl(): number {
    return this.formulario.get(this.nameControl).value;
  }

}
